import { render, staticRenderFns } from "./PartnerTransactionDetail.vue?vue&type=template&id=23049dba&scoped=true&"
import script from "./PartnerTransactionDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerTransactionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23049dba",
  null
  
)

export default component.exports